<main>

<h2>Thanks for shopping with Dumpster Fire! <ion-icon class="share-button" name="share-outline" size="large" on:click={() => {
    navigator.share({
      title: "Dumpster Fire - Shop",
      url: location.href
    });
  }}/></h2>

<h4>The Official Shop is now Open!</h4>
<figure>
    <a href="https://shop.dumpster.fr"><img src="images/tshirtmodel.webp" alt="Model wearing Dumpster Fire tee shirt" /></a>
<figcaption>One of the many beautiful products at <a href="https://shop.dumpster.fr">shop.dumpster.fr</a>!</figcaption>
</figure>
<p>Dumpster Fire's Official Merch shop is now open and available at <a href="https://shop.dumpster.fr">shop.dumpster.fr</a>!</p>
<figure>
    <a href="https://shop.dumpster.fr"><img src="images/hoodiemodel.webp" alt="Model wearing Dumpster Fire hoodie" /></a>
<figcaption>Did someone say hoodies? We got 'em! All that and more at <a href="https://shop.dumpster.fr">shop.dumpster.fr</a>!</figcaption>
</figure>
<p>Dumpster Fire makes zero profit from any purchases and all sales/orders are handled by Spreadshirt.</p>
</main>
<style>
    img {
        opacity: 1 !important;
    }
</style>